export const whyWithAiGenerate = [
	{
		icon: '🚀',
		subtitle: 'whyWithAiData_subtitle1',
	},
	{
		icon: '🤘',
		subtitle: 'whyWithAiData_subtitle2',
	},
];
